import React, { createContext, useContext } from "react";
import { getData } from "./Api";

const data = {
  loading: false,
  error: false,
  data: [],
};

const galleryReducer = (state, action) => {
  switch (action.type) {
    case "LOADING":
      return { ...state, loading: true, error: false };
    case "SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload,
      };
    case "ERROR":
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

const GalleryContext = createContext();

export const GalleryProvider = ({ children }) => {
  const [galleryState, dispatch] = React.useReducer(galleryReducer, data);

  const getGalleryAssets = async () => {
    dispatch({ type: "LOADING" });
    try {
      const urlPath = `/images?type=gallery/`;
      await getData(urlPath).then((data) => {
        if (data?.type === "ERROR") { 
            return dispatch({
            type: "ERROR",
            payload: data.payload
        })}
        return dispatch({
          type: "SUCCESS",
          payload: data.payload?.urls
        });
      });
    } catch (error) {
      return dispatch({
        type: "ERROR",
        payload: error,
      });
    }
  };

  return (
    <GalleryContext.Provider value={{ getGalleryAssets, galleryState }}>
      {children}
    </GalleryContext.Provider>
  );
};

export const useGallery = () => {
  const context = useContext(GalleryContext);

  if (!context) {
    return new Error("Provider required");
  }
  return context;
};
